import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import {
  APP_V2_APP_EVENTS,
  APP_V2_USER_EVENTS,
  logError,
  logEvent,
} from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { openUrlInBrowser } from "@src/appV2/NativeAdapters/browser.adapter";
import { useModalState } from "@src/appV2/redesign/system/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { NursesWeekNominationBanner } from "./Banner";
import { NursesWeekNominationBottomSheet } from "./BottomSheet";

const NOMINATION_FORM_URL =
  "https://support.clipboardhealth.com/hc/en-us/requests/new?ticket_form_id=39628176620183";

export function NursesWeekNominationEntrypoint() {
  const bottomSheetModalState = useModalState();

  const { userId } = useDefinedWorker();

  const isNursesWeekNominationEnabled = useCbhFlag(CbhFeatureFlag.NURSES_WEEK_NOMINATION, {
    defaultValue: false,
  });

  useLogEffect(
    APP_V2_USER_EVENTS.NURSES_WEEK_NOMINATION_BANNER_SHOWN,
    { workerId: userId },
    { enabled: isNursesWeekNominationEnabled }
  );

  if (!isNursesWeekNominationEnabled) {
    return null;
  }

  const handleBannerCtaClick = () => {
    bottomSheetModalState.openModal();
    logEvent(APP_V2_USER_EVENTS.NURSES_WEEK_NOMINATION_BANNER_CTA_CLICKED, {
      workerId: userId,
    });
  };

  const handleNominateClick = async () => {
    logEvent(APP_V2_USER_EVENTS.NURSES_WEEK_NOMINATION_NOMINATE_CTA_CLICKED, {
      workerId: userId,
    });
    try {
      await openUrlInBrowser(NOMINATION_FORM_URL, "nurses-week-nomination");
    } catch (error: unknown) {
      logError(APP_V2_APP_EVENTS.NURSES_WEEK_NOMINATION_OPEN_URL_FAILURE, {
        error,
        metadata: { workerId: userId },
      });
    }
  };

  return (
    <>
      <NursesWeekNominationBanner onClick={handleBannerCtaClick} />
      <NursesWeekNominationBottomSheet
        modalState={bottomSheetModalState}
        onNominateClick={handleNominateClick}
      />
    </>
  );
}
